import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';

import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputSwitch } from 'primereact/inputswitch';

import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import TagInativo from '../../../Componentes/TagInativo';
import TagAtivo from '../../../Componentes/TagAtivo';
import UpdateButton from '../../../Componentes/UpdateButton';

import { TabView, TabPanel } from 'primereact/tabview';
import FormDCAs from './FormDcas';
import TonerSlider from '../../../Componentes/TonerSlider';


export default function FormLicencasCollector(props) {

        const gerarChaveDCA = (cnpj) => {
            return cnpj?.replace(/[.\-\/]/g, ""); 
        };
        const toast = React.useRef(null); // Ref para o Toast
        const [fieldsFound, setFieldsFound] = useState([]);
        const [dcas, setDcas] = useState([]);
        const [licencasCollector, setLicencasCollector] = useState(props.licencasCollector);
        const [licencaCollector, setLicencaCollector] = useState([]);
        const [globalFilterValue, setGlobalFilterValue] = useState('');
        const [edicao, setEdicao] = useState(false)
        const [activeIndex, setActiveIndex] = useState(0);
        const carregandoDcas = useRef(false); // Evita múltiplas chamadas

        const [dataLicenca, setDataLicenca] = useState({
            idusuario: props.dataEmpresa.idrevenda,
            idempresa: props.dataEmpresa.idempresa,
            idcliente: props.idcliente,
            razaosocial: props.cliente.razaosocial,
            chave: 'DB' + gerarChaveDCA(props.dataEmpresa.cnpj)+'-'+props.dataEmpresa.idempresa+'-'+props.idcliente,
            codigoClienteERP: 0, 
            monitorartoner : "t",
            ativo : 't', 
            equipamentos : 0, 
        })

        

        const [chaveDCA, setChaveDCA]= useState({
                chave: '',
                idusuario: props.dataEmpresa.idrevenda,
                idempresa: props.dataEmpresa.idempresa,
                idcliente: props.idcliente,
                explode: "T",
                razaosocial: props.cliente.razaosocial,
                serviceInventory: false
                });


        useEffect(()=>{
            setLicencasCollector(props.licencasCollector)
        }, [props.licencasCollector])

        useEffect(()=>{

            setChaveDCA((prevData)=>({
                ...prevData, 
                chave : 'DB' + gerarChaveDCA(props.dataEmpresa.cnpj)+'-'+props.dataEmpresa.idempresa+'-'+props.idcliente
            }))

            const agora = new Date();

            const dataHoraFormatada = agora.toLocaleString("pt-BR");

            setDataLicenca({
                idusuario: props.dataEmpresa.idrevenda,
                idempresa: props.dataEmpresa.idempresa,
                idcliente: props.idcliente,
                razaosocial: props.cliente.razaosocial,
                chave: 'DB' + gerarChaveDCA(props.dataEmpresa.cnpj)+'-'+props.dataEmpresa.idempresa+'-'+props.idcliente,
                codigoClienteERP: 0,
                monitorartoner : "t",
                ativo : 't', 
                equipamentos : 0, 
                datacriacao : dataHoraFormatada
            })


        }, [props.idcliente])

       
      
    
       
    
        const op = useRef(null); // Referência para o OverlayPanel
    
        const [loading, setLoading] = useState(false);
    
       
        useEffect(() => {
                if (!carregandoDcas.current && activeIndex == 0) {
                    carregandoDcas.current = true;
         
                    getDca();
                }
            }, [activeIndex]); // Executa apenas quando 'cliente' mudar


       
        const getDca = async () => {
            if(props.setLoading){
                props.setLoading(true)
            }
            try {
                const response = await Conexao.post('dcaController/getDca',{
                    idusuario : props.dataEmpresa.idrevenda, 
                    idempresa : props.dataEmpresa.idempresa, 
                    idcliente : props.idcliente
                }                );
                setDcas(response.status === 200 && response.data.status === 'OK' ? response.data.payload : []);
                if(props.setLoading){
                    props.setLoading(false)
                }
            } catch {
                setDcas([]);
                if(props.setLoading){
                    props.setLoading(false)
                }
            }
        };



        const [filters, setFilters] = useState({
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                idempresa: { value: '', matchMode: FilterMatchMode.CONTAINS },
                idcliente: { value: '', matchMode: FilterMatchMode.EQUALS },
                razaosocial: { value: '', matchMode: FilterMatchMode.EQUALS },
                chave: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
                monitorartoner: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
                desativado: { value: '', matchMode: FilterMatchMode.EQUALS },
               
            });

         const clearFilters = () => {
                setGlobalFilterValue('');
                setFilters({
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    idempresa: { value: '', matchMode: FilterMatchMode.CONTAINS },
                    idcliente: { value: '', matchMode: FilterMatchMode.EQUALS },
                    razaosocial: { value: '', matchMode: FilterMatchMode.EQUALS },
                    chave: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
                    monitorartoner: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
                    desativado: { value: '', matchMode: FilterMatchMode.EQUALS }
                });
                setFieldsFound([]); // Resetando os campos encontrados
            };


           
    const onGlobalFilterChange = (e) => {

        const value = e.target.value.toLowerCase();

        setGlobalFilterValue(value);
    
        // Atualizar o filtro global corretamente
        setFilters(prevFilters => ({
            ...prevFilters,
            global: { ...prevFilters.global, value }
        }));
           
        
    };

    const renderHeader = () => {
            return (
                <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '10px', paddingLeft : '0px'}}>
                   
                    <div className="flex align-items-center gap-2">
                        <IconField iconPosition="left">
                            <InputIcon className="pi pi-search" />
                            <InputText 
                                value={globalFilterValue} 
                                onChange={onGlobalFilterChange} 
                                placeholder="Pesquisa global" 
                                tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                            />
                        </IconField>
                        <Button 
                            icon="pi pi-filter-slash" 
                            className="p-button-secondary p-button-sm" 
                            onClick={clearFilters} 
                            tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                        />
                        
                        <Button 
                            icon="pi pi-plus"

                            className= "p-button-primary p-button-sm" 
                            disabled ={licencasCollector.length > 0 || props.fixarCliente}
                            tooltip="Nova Licença" tooltipOptions={{ position: 'bottom' }}
                            onClick={()=>{
                                if(props.dataEmpresa.bloqueiofinanceiro === 't') {
                           
                                    props.showMessage("warn", 'Datacount - Licença', 'Este recurso esta Bloqueado! Entre em contato com a Databit');
                                    return;
                                }  
                                confirmDialog({
                                    message: 'Confirma a Ativação de uma Chave para o cliente?',
                                    header: 'Confirmação',
                                    icon: 'pi pi-exclamation-triangle',
                                    acceptLabel: 'Sim',
                                    rejectLabel: 'Não',
                                    accept: () => {
                                       props.setLoading(true)
                                       props.Conexao.post('dcaController/insertLicencaCollector', {
                                        ...dataLicenca
                                        }).then(response=>{
                                            if(response.status == 200 && response.data.status == 'OK'){
                                                props.setLicencasCollector(prevData => [...prevData, dataLicenca]); 
                                                props.showMessage('success', 'Cadastro de Licenças', 'Registro inserido com sucesso!')  
                                            }else{
                                                props.showMessage('warn', 'Cadastro de Licenças', 'Não foi possível inserir registro')  
                                            }
                                            props.setLoading(false)                                   
                                        }).catch(error=>{
                                            props.showMessage('error', 'Cadastro de Licenças', 'Não foi possível inserir registro')  
                                            props.setLoading(false)                                   
                                        })

                                        
                                    }
                                    });
                            }}
                        />            
                    </div>
                    
                </div>
            );
        };       

        const handleChange = (e) => {
            const { name, value } = e.target;
            setLicencaCollector(prevState => ({
                ...prevState,
                [name]: value
            }));
        };
        const handleChangeToner = (value, name) => {
            if(licencaCollector.monitorartoner === 'f'){
                return
            }
            setLicencaCollector(prevState => ({
                ...prevState,
                [name]: value
            }));
        };

        const handleTabChange = (e) => {
            setActiveIndex(e.index);
            console.log("Aba ativa:", e.index); // Mostra no console qual aba está ativa
        };

    return <div>
                {!edicao ? <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
                                <TabPanel header="Licenças" leftIcon="pi pi-sitemap mr-2 text-2xl">
                                    <DataTable
                    header={renderHeader()}
                    value={licencasCollector}
                    paginator                 
                    rows={15} // Número de itens por página
                    rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                    responsiveLayout="scroll"
                    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Registro {first} até {last} de {totalRecords} registro(s)" 
                    tableStyle={{ minWidth: '35rem', fontSize : '10px' }}                   
                    bodyStyle={{fontSize : '10px'}}
                    filters={filters} // **Adicione esta linha**
                    globalFilterFields={['idempresa', 'idcliente', 'razaosocial', 'chave', 'monitorartoner', 'datacriacao', 'desativado']}                            
                >
                     <Column 
                        bodyStyle={{ fontSize: '11px' , width : '10%' , paddingTop:'8px', paddingBottom: '8px'}} 
                        headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px' }} 
                        field="chave" 
                        header="Chave" 
                        name="chave" 
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                        sortable />
                    <Column 
                        bodyStyle={{ fontSize: '11px' , width : '20%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'12px' , paddingTop:'8px', paddingBottom: '8px'}} 
                        field="datacriacao" 
                        header="Criação" 
                        name="datacriacao" 
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                        sortable />

                    <Column 
                        bodyStyle={{ fontSize: '11px' , width : '20%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'12px' , paddingTop:'8px', paddingBottom: '8px'}} 
                        field="equipamentos" 
                        header="Equipamentos" 
                        name="equipamentos" 
                        sortable
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                         />

                    <Column 
                        bodyStyle={{ fontSize: '11px' , width : '10%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'12px' , paddingTop:'8px', paddingBottom: '8px',}} 
                        header="Monitoramento" 
                        className='text-center'
                        field='monitorartoner'
                        body={(row)=>loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : 
                        row.monitorartoner === 't' ? <TagAtivo tooltip ='Esta licença de coleta esta ATIVA'
                         tooltipOptions={{ position: 'left' }}/>
                       
                        :  
                        <TagInativo tooltip ='Esta licença de coleta esta INATIVA'
                         tooltipOptions={{ position: 'left' }}/>
                        }
                         />
                    

                    <Column 
                        bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px' , textAlign:'center' }} 
                        headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px',  }} 
                        header="Editar"
                        body={(row)=> loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : <UpdateButton tooltip ='Ativar/Desativar licença e Habilitar monitoramento de suprimentos'
                         tooltipOptions={{ position: 'left' }} style={{padding : '2px'}}
                         className='w-full'
                         onClick = {()=>{
                            if(props.fixarCliente){
                                return
                            }
                            setEdicao(true)
                            setLicencaCollector(row)
                         }}/>}                         
                    />

                    <Column 
                        header="Status"
                        bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px' , textAlign:'center' }} 
                        headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px',  }} 
                        body={(row)=>loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : 
                        row.ativo === 't' ? <TagAtivo/>
                       
                        :  
                        <TagInativo/>
                        }                         
                    />


                </DataTable> </TabPanel>
                <TabPanel header="DCA´s" leftIcon="pi pi-share-alt mr-2 text-2xl" disabled={licencasCollector.length === 0} tooltip="Chaves de DCA responsáveis pelas coletas" >
                    <FormDCAs 
                        {...props} 
                        dcas = {dcas}
                        fixarCliente ={props.fixarCliente}
                        getDca ={getDca}                        
                        locaisInstalacao = {props.locaisInstalacao}
                        setDcas = {setDcas}
                        Conexao = {props.Conexao}
                        getLocaisByCliente ={props.getLocaisByCliente}
                        showMessageToast ={props.showMessageToast}
                        chaveDCA ={chaveDCA}/>
                </TabPanel>
                </TabView>:
                <div>
                    <div className="flex flex-wrap gap-0 "  >
                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">Licença Ativa</span><br/>
                            <InputSwitch 
                                checked={licencaCollector.ativo === 't'} 
                                className="mt-2" 
                                onClick={(e) => {
                                    setLicencaCollector((prevState) => ({
                                        ...prevState, 
                                        ativo: e.target.checked ? 't' : 'f',
                                    }));
                                }} 
                            />
                        </div>
                    </div>
                    <div className="flex flex-wrap gap-0 "  >
                        {/* Exibindo informações da cliente */}
                        <div className="col-12 md:col-4">
                            <span className="font-medium text-lg">Chave de Instalação</span>
                            <InputText           
                                value = {licencaCollector.chave}                                
                                name="chave"
                                className="w-full mt-2"
                            />
                        </div>
                        <div className="col-12 md:col-3">
                            <span className="font-medium text-lg">Data Criação</span>
                            <InputText           
                                value = {licencaCollector.datacriacao}                                
                                name="datacriacao"
                                className="w-full mt-2"
                            />
                        </div>
                        <div className="col-12 md:col-3">
                            <span className="font-medium text-lg">Hora Criação</span>
                            <InputText           
                                value = {licencaCollector.horacriacao}                                
                                name="horacriacao"
                                className="w-full mt-2"
                            />
                        </div>
                        <div className="col-12 md:col-2">
                            <span className="font-medium text-lg">Equipamentos</span>
                            <InputText           
                                value = {licencaCollector.equipamentos}                                
                                name="horacriacao"
                                className="w-full mt-2"
                            />
                        </div>
                        

                        <div className="col-12 md:col-3" style={{marginTop : '10px'}}> 
                            <span className="font-medium text-lg">Monitorar Suprimentos</span><br/>
                            <InputSwitch 
                                checked={licencaCollector.monitorartoner === 't'} 
                                className="mt-2" 
                                placeholder="Right" 
                                tooltip="Habilite o monitoramento de níveis de toner, assim quando o nível chega ao alvo marcado abaixo, automáticamente é gerado um alerta para o suprimento." 
                                onClick={(e) => {
                                    setLicencaCollector((prevState) => ({
                                        ...prevState, 
                                        monitorartoner: e.target.checked ? 't' : 'f',
                                    }));
                                }} 
                            />
                        </div>
                        
                    </div>
                    
                    <div className="grid gap-5" style={{marginTop : '10px'}}>
                        <div className="col-12 md:col-12 pr-10, pl-5" style={{paddingRight : '20px'}}>
                            <TonerSlider 
                                    min={0}
                                    max={100} 
                                    disabled ={licencaCollector.monitorartoner === 'f'} 
                                    cor = 'C' color='#1565C0' 
                                    valor={licencaCollector.nivelciano} 
                                    onChange={(value)=>{
                                        handleChangeToner(value, 'nivelciano')
                                    }}/>
                            <TonerSlider 
                                    disabled ={licencaCollector.monitorartoner === 'f'} 
                                    cor = 'M' 
                                    color='#E91E63' 
                                    valor={licencaCollector.nivelmagenta} 
                                    onChange={(value)=>{
                                        handleChangeToner(value, 'nivelmagenta')
                                    }}/>

                            <TonerSlider 
                                    disabled ={licencaCollector.monitorartoner === 'f'} 
                                    cor = 'Y' color='#FBC02D' 
                                    valor={licencaCollector.nivelamarelo} 
                                    onChange={(value)=>{
                                        handleChangeToner(value, 'nivelamarelo')
                                    }}/>

                            <TonerSlider 
                                    disabled ={licencaCollector.monitorartoner === 'f'} 
                                    cor = 'K' 
                                    color='#000' 
                                    valor={licencaCollector.nivelpreto} 
                                    onChange={(value)=>{
                                        handleChangeToner(value, 'nivelpreto')
                                    }}/>
                        </div>
                    </div>
                    <div className="mt-4 flex justify-content-end mt-2">
                        <Button disabled={props.loading} severity="secondary" className="mt-2 mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                                confirmDialog({
                                message: 'Deseja cancelar?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: 'Sim',
                                rejectLabel: 'Não',
                                accept: () => {
                                    setLicencaCollector([])
                                    setEdicao(false)
                                }
                            });
                        }} />
                        <Button disabled={props.loading} severity="primary" className="mt-2 mr-2" label="Salvar" icon="pi pi-save" onClick={() => {
                                
                                confirmDialog({
                                message: 'Confirma a inclusão desse novo Cliente?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: 'Sim',
                                rejectLabel: 'Não',
                                accept: () => {
                                    props.setLicencasCollector((prevLocais) => [
                                        ...prevLocais.filter(licenca => licenca.chave !== licencaCollector.chave), 
                                        {...licencaCollector}
                                    ]);
                                    setEdicao(false)
                                }
                                });
                        }} />
                    </div>

                </div>
                        }
    </div>

}